import optionsApi from '../../api/options';
import Test from "../../classes/models/Test";

const state = () => ({
    ageOptions: [],
    countryLanguageOptions: [],
    predefinedTestersPanelOptions: [],
    testersPackagesOptions: [],
    questions: [],
    audienceRequirements: [],
    participantsCount: 0,
    areParticipantsCounting: false
});

// getters
const getters = {
    ageOptions(state) {
        return state.ageOptions;
    },
    countryLanguageOptions(state) {
        return state.countryLanguageOptions;
    },
    predefinedTestersPanelOptions(state) {
        return state.predefinedTestersPanelOptions;
    },
    testersPackagesOptions(state) {
        return state.testersPackagesOptions;
    },
    questions(state) {
        return state.questions;
    },
    audienceRequirements(state) {
        return state.audienceRequirements;
    },
    participantsCount(state) {
        return state.participantsCount;
    },
    areParticipantsCounting(state) {
        return state.areParticipantsCounting;
    },

};

// actions
const actions = {
    loadAgeOptions({commit, state, dispatch}, data) {
        commit('setIsLoading', true, {root: true});
        return optionsApi.ageOptions(data).then(response => {
            commit('setAgeOptions', response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadCountryLanguageOptions({commit, state}) {
        commit('setIsLoading', true, {root: true});
        return optionsApi.countryLanguageOptions().then(response => {
            commit('setCountryLanguageOptions', response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadPredefinedTestersPanelOptions({commit, state}) {
        commit('setIsLoading', true, {root: true});
        return optionsApi.predefinedTestersPanelOptions().then(response => {
            commit('setPredefinedTestersPanelOptions', response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadTestersPackagesOptions({commit, state}) {
        commit('setIsLoading', true, {root: true});
        return optionsApi.testersPackagesOptions().then(response => {
            commit('setTestersPackagesOptions', response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadTesterStepOptions({commit, state, dispatch}) {
        return Promise.all([
            dispatch('loadPredefinedTestersPanelOptions'),
            dispatch('loadTestersPackagesOptions'),
            dispatch('loadAudienceRequirements'),
            dispatch('loadCountryLanguageOptions'),
        ]);
    },
    loadQuestions({commit, state, dispatch}, testId) {
        commit('setIsLoading', true, {root: true});
        return optionsApi.questions(testId).then(response => {
            commit('setQuestions', response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadAudienceRequirements({commit, state, dispatch}, testId) {
        commit('setIsLoading', true, {root: true});
        return optionsApi.audienceRequirements(testId).then(response => {
            commit('setAudienceRequirements', response);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadParticipantsCount: _.debounce(({commit, state, dispatch}, options) => {
        if ((!options.attributes || options.attributes.length < 1) && !options.predefined_panel_id) {
            commit('setParticipantsCount', null);
            return Promise.resolve();
        }
        commit('setAreParticipantsCounting', true);
        return optionsApi.countParticipants(options).then(count => {
            commit('setParticipantsCount', count);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setAreParticipantsCounting', false);
        });
    }, 500),
};

// mutations
const mutations = {
    setAgeOptions(state, options) {
        state.ageOptions = options;
    },
    setCountryLanguageOptions(state, options) {
        state.countryLanguageOptions = options;
    },
    setPredefinedTestersPanelOptions(state, options) {
        state.predefinedTestersPanelOptions = options;
    },
    setTestersPackagesOptions(state, options) {
        state.testersPackagesOptions = options;
    },
    setQuestions(state, options) {
        state.questions = options;
    },
    setAudienceRequirements(state, options) {
        state.audienceRequirements = options;
    },
    setParticipantsCount(state, count) {
        state.participantsCount = count;
    },
    setAreParticipantsCounting(state, isLoading) {
        state.areParticipantsCounting = isLoading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
